import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { AlertModule } from '../_helpers/alert.module';

@Injectable({
    providedIn: AlertModule
})
export class AlertService {
    private subject = new BehaviorSubject<any>(null);
    private keepAfterNavigationChange = false;

    constructor(private router: Router) {
        // Clear alert message on route change
        router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                if (this.keepAfterNavigationChange) {
                    this.subject.next(this.subject.value)
                    // Only keep for a single location change
                    this.keepAfterNavigationChange = false;
                } else {
                    // Clear alert
                    this.subject.next(null);
                }
            }
        });
    }

    success(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'success', text: message });
    }

    error(message: string, keepAfterNavigationChange = false) {
        this.keepAfterNavigationChange = keepAfterNavigationChange;
        this.subject.next({ type: 'error', text: message });
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }

    clear() {
        this.subject.next(null);
    }
}
